import { render } from "./Index.vue?vue&type=template&id=450be85f&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=450be85f&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=450be85f&lang=css"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450be85f"]])

export default __exports__